module.exports = __webpack_public_path__ + "static/media/ic-info-filled.96dcb80e.svg";